// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:host ::ng-deep .mat-mdc-dialog-container .mdc-dialog__surface {
  border-radius: 0 !important;
}

:host {
  display: block;
}

.dialog-content {
  display: flex;
  flex-direction: column;
  gap: 10px;
  min-width: min(480px, 100%);
}

.loading-state {
  display: flex;
  justify-content: center;
  padding: 20px 0;
}

.action-error {
  color: #a94442;
  font-size: 0.8rem;
}

.details-grid {
  display: grid;
  grid-template-columns: auto 1fr;
  column-gap: 12px;
  row-gap: 6px;
  margin: 0;
  font-size: 0.85rem;
}

.details-grid dt {
  font-weight: 600;
  color: #555;
}

.details-grid dd {
  margin: 0;
  word-break: break-word;
}`, "",{"version":3,"sources":["webpack://./src/app/pages/job-details/job-request-details/formulation-iterations/material-details-popup/material-details-popup.component.scss"],"names":[],"mappings":"AAAA;EACE,2BAAA;AACF;;AAEA;EACE,cAAA;AACF;;AAEA;EACE,aAAA;EACA,sBAAA;EACA,SAAA;EACA,2BAAA;AACF;;AAEA;EACE,aAAA;EACA,uBAAA;EACA,eAAA;AACF;;AAEA;EACE,cAAA;EACA,iBAAA;AACF;;AAEA;EACE,aAAA;EACA,+BAAA;EACA,gBAAA;EACA,YAAA;EACA,SAAA;EACA,kBAAA;AACF;;AAEA;EACE,gBAAA;EACA,WAAA;AACF;;AAEA;EACE,SAAA;EACA,sBAAA;AACF","sourcesContent":[":host ::ng-deep .mat-mdc-dialog-container .mdc-dialog__surface {\n  border-radius: 0 !important;\n}\n\n:host {\n  display: block;\n}\n\n.dialog-content {\n  display: flex;\n  flex-direction: column;\n  gap: 10px;\n  min-width: min(480px, 100%);\n}\n\n.loading-state {\n  display: flex;\n  justify-content: center;\n  padding: 20px 0;\n}\n\n.action-error {\n  color: #a94442;\n  font-size: 0.8rem;\n}\n\n.details-grid {\n  display: grid;\n  grid-template-columns: auto 1fr;\n  column-gap: 12px;\n  row-gap: 6px;\n  margin: 0;\n  font-size: 0.85rem;\n}\n\n.details-grid dt {\n  font-weight: 600;\n  color: #555;\n}\n\n.details-grid dd {\n  margin: 0;\n  word-break: break-word;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
